import { IonIcon } from '@ionic/react';
import Button from 'components/core/Button/Button';
import ScreenAdapter, { ScreenConstraint } from 'components/core/ScreenAdapter';
import { cloudDownloadOutline, logoGithub } from 'ionicons/icons';
import { HStack, VStack } from 'reaction';
import './CTAButtonGroup.css';

export interface CTAButtonProps {
    icon: string;
    label: string;
}

export default function CTAButtonGroup() {
    return (
        <ScreenAdapter>
            <ScreenConstraint minWidth={500}>
                <HStack justify='start'>
                    <CTAButton icon={cloudDownloadOutline} label='Download Latest Resume' />
                    <CTAButton icon={logoGithub} label='View on GitHub' />
                </HStack>
            </ScreenConstraint>
            <ScreenConstraint maxWidth={499}>
                <VStack justify='start' align='start'>
                    <CTAButton icon={cloudDownloadOutline} label='Download Latest Resume' />
                    <CTAButton icon={logoGithub} label='View on GitHub' />
                </VStack>
            </ScreenConstraint>
        </ScreenAdapter>
    );
}

export function CTAButton({ icon, label }: CTAButtonProps) {
    return (
        <Button onClick={() => undefined} className='cta-button'>
            <HStack>
                <IonIcon icon={icon} size='large' className='cta-button-icon' />
                {label}
            </HStack>
        </Button>
    );
}
